const _getDefaultLanguage = (languages) => {
  return languages.find((lang) => lang.default);
};

const _getLanguageOrDefault = (languages, language) => {
  let lang = languages.find((lang) => lang.tag === language);
  if (!lang) {
    lang = _getDefaultLanguage(languages);
  }
  return lang;
};

/**
 * Return the default language to be used by the application
 * @param languages
 * @return {string}
 */
export const getDefaultLanguage = (languages) => {
  return _getDefaultLanguage(languages).tag;
};

/**
 * Checks if a given language is defined as RTL
 * @param languages
 * @param language
 * @return {boolean}
 */
export const getLanguageRtl = (languages, language) => {
  return _getLanguageOrDefault(languages, language).rtl;
};

/**
 * Return all supported language tags for the application
 * eg ["en", "fr", "ar"]
 * @param languages
 * @return {string[]}
 */
export const getSupportedLanguages = (languages) => {
  return languages?.map((language) => language.tag) || [];
};

/**
 * Checks if the language passed as parameter is support by the application
 * @param languages
 * @param language
 * @return {string}
 */
export const getSupportedLanguage = (languages, language) => {
  return _getLanguageOrDefault(languages, language).tag;
};

/**
 * Returns the preferred language of the user by reading the local storage of the browser.
 *
 * @deprecated Use the AppContext instead to read the preferred language.
 * @return {string}
 */
export const getUserLanguage = () => {
  const userLanguage = localStorage.getItem("UserLanguagePreference");
  const availableLanguages = ["en", "fr", "ar"];
  const defaultLanguage = "en";
  if (availableLanguages.includes(userLanguage)) {
    return userLanguage;
  } else {
    return defaultLanguage;
  }
};
